import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M20 20H14.5L16.549 17.95L13.42 14.82L14.83 13.41L17.96 16.539L20 14.5V20ZM5.41 20L4 18.59L16.54 6.04L14.5 4H20V9.5L17.96 7.46L5.411 20H5.41ZM9.17 10.58L4 5.41L5.41 4L10.59 9.17L9.17 10.579V10.58Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Shuffle"
);
